import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";

const PublicLayout = ({ children }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);

  return (
    <div className="App relative min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 pt-0">{children}</main>
      <Footer />
    </div>
  );
};

export default PublicLayout;
